import React, { useEffect, useState } from "react";
import { ArrowUpRight, CalendarDays } from "lucide-react";
import { EVENTS, OPEN_PLAY, BOOKING_URL } from "../../mock/mock";
import { fetchPublic } from "../adminApi";
import D2Banner from "../D2Banner";
import ShareButtons from "../ShareButtons";
import { Reveal, SplitWords } from "../motionHelpers";

export default function EventsPage2() {
  const [events, setEvents] = useState(EVENTS);
  useEffect(() => {
    fetchPublic("events").then((d) => { if (d && d.length) setEvents(d); }).catch(() => {});
  }, []);
  return (
    <div>
      <D2Banner eyebrow="On the Calendar" title="Events & Tournaments" subtitle="Tournaments, leagues, open play and clinics for every skill level — all DUPR-rated." image={(events[0] && events[0].image) || EVENTS[0].image} crumbs={[{ label: "Events & Tournaments" }]} />

      <section className="d2-bg py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
          <div className="grid md:grid-cols-2 gap-6">
            {events.map((e, i) => (
              <Reveal key={e.title} delay={i * 0.08}>
                <div data-hover className="group d2-card flex flex-col sm:flex-row bg-[#0b241a] border border-white/10 rounded-2xl overflow-hidden h-full">
                  <div className="sm:w-2/5 h-52 sm:h-auto overflow-hidden">
                    <img src={e.image} alt={e.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  </div>
                  <div className="p-6 flex flex-col justify-center sm:w-3/5">
                    <span className="bg-sc-lime text-sc-green font-grotesk font-bold uppercase text-[11px] tracking-widest px-3 py-1 w-fit">{e.tag}</span>
                    <h3 className="font-display uppercase text-2xl text-white mt-3 leading-tight">{e.title}</h3>
                    <p className="font-mono2 text-xs text-sc-lime uppercase tracking-widest mt-2 flex items-center gap-2"><CalendarDays className="w-4 h-4" />{e.date} · {e.level}</p>
                    <div className="flex flex-wrap items-center gap-4 mt-5">
                      <a href={BOOKING_URL} className="d2-btn inline-flex items-center gap-2 px-5 py-2.5 text-xs w-fit">Register <ArrowUpRight className="w-3.5 h-3.5" /></a>
                      <ShareButtons event={e} size="md" />
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-sc-cream py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <span className="font-grotesk uppercase tracking-[0.3em] text-sc-orange text-sm">Every Day</span>
            <h2 className="font-display uppercase text-sc-green text-4xl md:text-6xl leading-[0.92] mt-3">
              <SplitWords text="Weekly Open Play" />
            </h2>
            <p className="text-gray-600 mt-5 text-lg font-grotesk">Drop in any day of the week. Paddles up, rotate in, and meet the community. All sessions are DUPR-logged.</p>
            <a href={BOOKING_URL} className="btn-green inline-flex items-center gap-3 px-8 py-4 mt-8 text-sm font-bold">Book Open Play <ArrowUpRight className="w-4 h-4" /></a>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="bg-sc-lime p-10 rounded-2xl">
              <h3 className="font-display uppercase text-3xl text-sc-green mb-6">{OPEN_PLAY.title}</h3>
              <ul className="space-y-2">
                {OPEN_PLAY.slots.map((s) => (
                  <li key={s.day} className="flex items-center justify-between border-b border-sc-green/15 pb-2 font-mono2 uppercase text-sc-green text-sm">
                    <span className="font-bold">{s.day}</span><span>{s.time}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
